import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Storage from '@material-ui/icons/Storage';

import { handleClickAway } from 'services/handleClickAway';
import AddDatabaseFormContainer from 'components/AddDatabaseForm/AddDatabaseFormContainer';
import PopoutItem from 'components/PopoutItem/PopoutItem';
import styles from '../InstanceButtonItem.styles';

const propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    actionButton: PropTypes.string.isRequired,
    popoutIconContainer: PropTypes.string.isRequired,
    popoutIconLabel: PropTypes.string.isRequired,
  }).isRequired,
  setUiState: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  anchorEl: PropTypes.shape({}).isRequired,
  statusDisplay: PropTypes.string.isRequired,
  instanceId: PropTypes.string.isRequired,
  service: PropTypes.string.isRequired,
};

export function UnstyledDatabaseInstanceButtonItem({
  open,
  classes,
  setUiState,
  disabled,
  anchorEl,
  statusDisplay,
  instanceId,
  service,
}) {
  function handleClick(e) {
    e.stopPropagation();

    setUiState({
      open: !open,
      anchorEl: e.currentTarget,
    });
  }

  const theButton = (
    <div className={classes.instanceButtonItemContainer}>
      <Button
        disabled={disabled}
        onClick={handleClick}
        classes={{ root: classes.zeroPadding, text: classes.zeroPadding }}
        className={classes.actionButton}
        id="userformpopout-button"
      >
        <div className={classes.popoutIconContainer}>
          <Storage disabled={disabled} className={classes.popoutIcon} />
          <span className={classes.popoutIconLabel}>Database</span>
        </div>
      </Button>
      <PopoutItem
        anchorEl={anchorEl}
        handleClick={handleClick}
        handleClickAway={(e) => handleClickAway(e, anchorEl, () => setUiState({ open: false }))}
        placement="bottom-end"
        open={open}
        popperId="databaseformpopout"
      >
        <AddDatabaseFormContainer
          instanceId={instanceId}
          service={service}
          closePopout={() => setUiState({ open: false })}
        />
      </PopoutItem>
    </div>
  );

  return disabled && statusDisplay === 'Ready' ? (
    <Tooltip
      title="You do not have the required access for this resource. Contact your organization owner."
      classes={{ tooltip: classes.tooltip }}
    >
      <span>{theButton}</span>
    </Tooltip>
  ) : (
    theButton
  );
}

UnstyledDatabaseInstanceButtonItem.propTypes = propTypes;

export const uiConfig = {
  name: 'databaseformpopoutitem',
  state: () => ({
    open: false,
    anchorEl: {},
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledDatabaseInstanceButtonItem));
